import { Injectable } from '@angular/core';
import { filterNilValue, QueryEntity } from '@datorama/akita';
import { CompaniesStore, CompaniesState } from './companies.store';

@Injectable({ providedIn: 'root' })
export class CompaniesQuery extends QueryEntity<CompaniesState> {
    activeCompany$ = this.selectActive().pipe(filterNilValue());
    constructor(protected store: CompaniesStore) {
        super(store);
    }
}
